import { FormEventHandler, useState } from 'react';
import { validate } from 'email-validator';
import { CognitoUser } from 'amazon-cognito-identity-js';
import userPool from '../../utils/userPool';
import { useNavigate, useLocation, redirect } from 'react-router-dom';
import LogoBlack from '../LogoBlack';
import * as UI from '../common';
import { PinCode } from '../common';
import { toast } from 'react-hot-toast';

const ConfirmAccountView = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const email = searchParams.get('email');

  const [code, setCode] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [buttonText] = useState('Verify Account');

  if (!email) {
    redirect('/auth/forget-password');
    return null;
  }

  const handleVerifyAccount: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
   
    setLoading(true);
    setErrorMessage('');
   
    const user = new CognitoUser({ Username: email, Pool: userPool });
    user.confirmRegistration(code, true, (err, result) => {
      if (err) {
        switch (err.code) {
          case 'UserNotFoundException':
            setErrorMessage('User not found. Please ensure you have signed up.');
            break;
          case 'NotAuthorizedException':
            setErrorMessage('User is already confirmed.');
            break;
          case 'CodeMismatchException':
            setErrorMessage('Invalid confirmation code. Please check and try again.');
            break;
          default:
            setErrorMessage(err.message);
        }
        setLoading(false);
      } else {
        toast.success('Account Verified Successfully!');
        navigate('/auth/login');
      }
    });
  }

  const isDisabled = !validate(email || '') || !code || code.length < 6;

  return (
    <div className="flex justify-center items-center lg:flex lg:justify-center bg-[#F2F9FD] min-h-screen lg:min-h-full md:mt-[-7em] lg:mt-[1em] bigmd:mt-[-7em]">
      <div className=" mx-10 md:w-[450px] lg:w-[578px] h-[421px] bg-white lg:h-[647px] lg:px-[60px] lg:bg-white border lg:mx-40 lg:my-40 lg:px-[48px] lg:text-[#1C3041]">
        {errorMessage && <div className="text-[red] border bg-[red] bg-opacity-10 p-2 text-center">{errorMessage}</div>}
        <div>
          <div className="flex justify-center my-[20px] xl:my-0 lg:flex lg:justify-center lg:pt-[56px]">
            <LogoBlack />
          </div>
          <h1 className="lg:text-[32px] text-[20px] font-bold flex flex-col text-center  lg:font-bold lg:flex-col lg:text-center lg:pt-[47px]">Confirm your email</h1>
        </div>
        <div className=''>
          <p className="pt-[37px] lg:pt-[57px] pl-[15px] text-center lg:text-left">Hello dear,</p>
          <p className="pt-[37px] text-[14px] pl-[15px] lg:pt-[40px] lg:text-[16px] lg:text-[#5D6D73] font-light">
            To activate your account, we need you to confirm your email address. Input the code sent to your email
            address
          </p>
          <div className="lg:flex lg:justify-center lg:pt-[50px]">
            <form onSubmit={handleVerifyAccount}>
              <div className="w-full h-full mt-[15px] mb-[10px] xl:mt-0 xl:mb-0">
                <PinCode codeLength={6} onCodeComplete={setCode} />
              </div>
<div className='lg:mt-[-2em] 2xl:mt-[1em] xl:mt-[1em]'>
              <UI.Button text={buttonText} isLoading={loading} disabled={isDisabled} />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export { ConfirmAccountView };
